import Isotope from "isotope-layout/js/isotope.js";
const elems = document.querySelectorAll(".info-box .row");
elems.forEach((elem) => {
  const iso = new Isotope(elem, {
    itemSelector: ".grid-item",
    percentPosition: true,
    masonry: {
      columnWidth: ".grid-sizer",
      horizontalOrder: true,
      gutter: 0,
    },
  });

  //Retrigger layout if inside a tab component
  const parentTab = elem.closest(".tab-pane");
  if(!parentTab) return;
  const id = parentTab.getAttribute("id");
  const trigger = document.querySelector(`[data-bs-target="#${id}"]`);
  if (trigger) {
    trigger.addEventListener("shown.bs.tab", function () {
      iso.layout();
    });
  }
});
